import { cn, roundPercentage } from "@/lib/utils";
import { formatCurrency } from "@/utils/formatCurrency";

export const Price = ({ className, children }) => (
  <h3 className={cn("text-[22px] font-bold leading-[24px]", className)}>
    {children}
  </h3>
);

export const FinalPriceBadge = ({ className }) => (
  <p className={cn("text-gray2 text-[13px] text-right mr-1 underline font-medium", className)}>
    See Low Price in Cart
  </p>
);

export const DefaultPriceUi = ({ price_details, className, manualPrice }) => {
  const {
    cartPrice,
    displayPrice,
    savingAmount,
    savingPercentage,
    crossedPrice,
  } = price_details || {};

  const hasSavings = savingAmount && savingAmount > 0;

  return (
    <div className={cn("flex items-start gap-2 h-[42px]", className)}>
      <div>
        <div className={` relative inline-block ${cartPrice ? " after:content-[''] after:absolute after:block after:w-full after:top-[45%] after:bg-black after:h-[3px]" : ""}`}>
        <Price>{cartPrice ? formatCurrency(crossedPrice) : formatCurrency(displayPrice)}</Price>               
      </div>
       {cartPrice && <FinalPriceBadge />}
      </div>
      {!cartPrice && <div>
        {hasSavings && (
          <Price className="text-red2 text-[9px] leading-[11px]">
            Save {formatCurrency(savingAmount)}{" "}
            {savingPercentage ? roundPercentage(savingPercentage) : ""}
          </Price>
        )}
        <Price className="text-[9px] leading-[11px] line-through">
          {formatCurrency(crossedPrice)}
        </Price>
      </div>}
    </div>
  );
};
